module.exports = __webpack_public_path__ + "img/3.b60219c5.jpg";